// extracted by mini-css-extract-plugin
export default {"qrWrapper":"QRCodeComponent_qrWrapper__PXzbK","label":"QRCodeComponent_label__PNdPx"};